import { createFileRoute } from "@tanstack/react-router";
import { QueuesPage } from "@/features/queues/queues-page";

export const Route = createFileRoute("/_authenticated/queues/")({
  head: () => ({ meta: [{ title: "Queues · Rogue Admin" }] }),
  component: QueuesPage,
});
